import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useRoleScoreList } from "../../hooks/useRoleScoreList";
import { RulesScoreItem } from "./RulesScoreItem";

export interface RuleScoreListProps {
  isSameCustomer: boolean;
}

export function RuleScoreList({ isSameCustomer }: RuleScoreListProps) {
  const { t } = useTranslation();
  const { riskScore } = useRoleScoreList();

  return (
    <div>
      <RuleScoreListHeader>
        <Typography sx={{ letterSpacing: 0 }} variant="button">
          {t("Rule")}
        </Typography>
        <Typography sx={{ letterSpacing: 0 }} variant="button">
          {t("score")}
        </Typography>
      </RuleScoreListHeader>
      <Container>
        {riskScore.matchedRules.map((rule) => (
          <RulesScoreItem
            key={rule.id}
            isSameCustomer={isSameCustomer}
            rule={rule}
          />
        ))}
      </Container>
    </div>
  );
}

const RuleScoreListHeader = styled("header")({
  justifyContent: "space-between",
  display: "flex",
});

const Container = styled("div")({
  justifyContent: "space-between",
  flexDirection: "column",
  display: "flex",
});
